/*
 * Yake — yedek filtre (25 Eyl 2026)
 * ------------------------------------------------------------------
 * Shopify 5.000'den fazla ürünü olan koleksiyonlarda (Kadın, Yeni Gelenler…) filtre üretmiyor;
 * filtre panelinde yalnız "Göre sırala" kalıyordu. Bu dosya, Shopify filtre vermediğinde
 * panele marka / renk / beden / fiyat / stok filtrelerini koleksiyon uygulamasının
 * (App Proxy) facet verisinden çizer.
 *
 * Alanlar temanın kendi filtre formunun (facet-form) içindedir ve Shopify'ın standart
 * parametre adlarını kullanır (filter.p.vendor, filter.v.option.renk …). Tema seçimi adrese
 * yazar; yake-shuffle.js aynı adresi okuyup ürünleri uygulamadan filtreli getirir.
 * Blok [data-filter] DEĞİLDİR, bu yüzden tema filtreleri yeniden çizerken ona dokunmaz.
 */
(function () {
  'use strict';

  var cfgEl = document.querySelector('script[data-yake-shuffle]');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG || !CFG.collection || !CFG.proxy) return;

  var DIL = (document.documentElement.lang || 'tr').slice(0, 2).toLowerCase();
  var METIN = {
    tr: { marka: 'Marka', renk: 'Renk', beden: 'Beden', fiyat: 'Fiyat', stok: 'Yalnızca stoktakiler', ara: 'Ara…', temizle: 'Filtreleri temizle', enAz: 'En az', enCok: 'En çok', daha: 'Daha fazla göster', secili: 'Seçili filtreler' },
    ro: { marka: 'Marcă', renk: 'Culoare', beden: 'Mărime', fiyat: 'Preț', stok: 'Doar produse în stoc', ara: 'Caută…', temizle: 'Șterge filtrele', enAz: 'Minim', enCok: 'Maxim', daha: 'Arată mai multe', secili: 'Filtre selectate' },
    en: { marka: 'Brand', renk: 'Color', beden: 'Size', fiyat: 'Price', stok: 'In stock only', ara: 'Search…', temizle: 'Clear filters', enAz: 'Min', enCok: 'Max', daha: 'Show more', secili: 'Selected filters' }
  };
  var T = METIN[DIL] || METIN.tr;
  var ILK_GOSTER = 12;

  function qs() { return new URLSearchParams(location.search); }

  // yake-shuffle.js ile aynı sadeleştirme (Shopify handle kuralı)
  function handleize(s) {
    return String(s).normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/ı/g, 'i').replace(/İ/g, 'i').toLowerCase()
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function aktifMi() {
    var var_ = false;
    qs().forEach(function (v, k) { if (v && k.indexOf('filter.') === 0) var_ = true; });
    return var_;
  }

  var facetVerisi = null;
  function facetleriAl() {
    if (facetVerisi) return Promise.resolve(facetVerisi);
    var p = new URLSearchParams();
    p.set('collection', CFG.collection);
    p.set('page_size', '1');
    return fetch(CFG.proxy + '?' + p.toString(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { facetVerisi = (d && d.facets) || null; return facetVerisi; })
      .catch(function () { return null; });
  }

  // Seçili filtrelere göre toplam ürün sayısı ("Sonuçları görüntüle (N)")
  function toplamiGuncelle() {
    var p = new URLSearchParams();
    p.set('collection', CFG.collection);
    p.set('page_size', '1');
    qs().forEach(function (v, k) {
      if (!v) return;
      if (k === 'filter.p.vendor') p.append('vendor', v);
      else if (k === 'filter.v.price.gte') p.set('price_min', v);
      else if (k === 'filter.v.price.lte') p.set('price_max', v);
      else if (k === 'filter.v.availability') { if (v === '1') p.set('available', '1'); }
      else if (k.indexOf('filter.v.option.') === 0) {
        var h = k.slice('filter.v.option.'.length);
        var ad = (facetVerisi && (facetVerisi.options || []).map(function (o) { return o.name; }).filter(function (n) { return handleize(n) === h; })[0]) || h;
        p.append('option_' + ad, v);
      }
    });
    fetch(CFG.proxy + '?' + p.toString(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || typeof d.total !== 'number') return;
        document.querySelectorAll('#FacetDrawer results-count').forEach(function (el) { el.textContent = d.total; });
      })
      .catch(function () { /* yoksay */ });
  }

  function grupHtml(baslik, ad, degerler, seciliSet, aranabilir, anahtar) {
    if (!degerler || !degerler.length) return '';
    var satirlar = degerler.map(function (d, i) {
      var id = 'ykyf-' + anahtar + '-' + i;
      var secili = seciliSet.has(d.value);
      return '<li class="ykyf-satir' + (i >= ILK_GOSTER && !secili ? ' ykyf-gizli' : '') + '" data-ad="' + esc(String(d.value).toLowerCase()) + '">' +
        '<label for="' + id + '"><input type="checkbox" id="' + id + '" name="' + esc(ad) + '" value="' + esc(d.value) + '"' + (secili ? ' checked' : '') + '>' +
        '<span class="ykyf-deger">' + esc(d.value) + '</span><span class="ykyf-adet">(' + d.count + ')</span></label></li>';
    }).join('');
    var ara = aranabilir && degerler.length > ILK_GOSTER ? '<input type="search" class="ykyf-ara" placeholder="' + esc(T.ara) + '" autocomplete="off" form="ykyf-yok">' : '';
    var daha = degerler.length > ILK_GOSTER ? '<button type="button" class="ykyf-daha">' + esc(T.daha) + ' (' + degerler.length + ')</button>' : '';
    var acik = seciliSet.size > 0 ? ' open' : '';
    return '<details class="ykyf-grup"' + acik + '><summary>' + esc(baslik) + (seciliSet.size ? ' <span class="ykyf-sayi">' + seciliSet.size + '</span>' : '') + '</summary>' +
      '<div class="ykyf-icerik">' + ara + '<ul>' + satirlar + '</ul>' + daha + '</div></details>';
  }

  function ciz(host) {
    facetleriAl().then(function (f) {
      if (!f) { host.hidden = true; return; }
      var q = qs();
      var html = '';

      // seçili filtreler + temizle
      var seciliListe = [];
      q.forEach(function (v, k) { if (v && k.indexOf('filter.') === 0 && k !== 'filter.v.availability' && k.indexOf('filter.v.price') !== 0) seciliListe.push(v); });
      if (q.get('filter.v.price.gte') || q.get('filter.v.price.lte')) seciliListe.push((q.get('filter.v.price.gte') || '0') + ' – ' + (q.get('filter.v.price.lte') || '∞'));
      if (aktifMi()) {
        html += '<div class="ykyf-secili"><span>' + esc(T.secili) + ':</span> ' + seciliListe.map(function (s) { return '<em>' + esc(s) + '</em>'; }).join(' ') +
          ' <a href="' + esc(location.pathname) + '" class="ykyf-temizle">' + esc(T.temizle) + '</a></div>';
      }

      var stokSecili = q.get('filter.v.availability') === '1';
      html += '<label class="ykyf-stok"><input type="checkbox" name="filter.v.availability" value="1"' + (stokSecili ? ' checked' : '') + '> ' + esc(T.stok) + '</label>';

      var vendors = (f.vendors || []).slice().sort(function (a, b) { return b.count - a.count; });
      html += grupHtml(T.marka, 'filter.p.vendor', vendors, new Set(q.getAll('filter.p.vendor')), true, 'marka');

      (f.options || []).forEach(function (o) {
        var h = handleize(o.name);
        var baslik = h === 'renk' ? T.renk : (h === 'beden' ? T.beden : o.name);
        var vals = (o.values || []).slice().sort(function (a, b) { return b.count - a.count; });
        html += grupHtml(baslik, 'filter.v.option.' + h, vals, new Set(q.getAll('filter.v.option.' + h)), true, h);
      });

      if (f.price && f.price.max) {
        var gte = q.get('filter.v.price.gte') || '', lte = q.get('filter.v.price.lte') || '';
        html += '<details class="ykyf-grup"' + (gte || lte ? ' open' : '') + '><summary>' + esc(T.fiyat) + '</summary><div class="ykyf-icerik ykyf-fiyat">' +
          '<input type="number" inputmode="numeric" min="0" max="' + Math.ceil(f.price.max) + '" name="filter.v.price.gte" placeholder="' + esc(T.enAz) + '" value="' + esc(gte) + '">' +
          '<span>–</span><input type="number" inputmode="numeric" min="0" max="' + Math.ceil(f.price.max) + '" name="filter.v.price.lte" placeholder="' + esc(T.enCok) + ' (' + Math.ceil(f.price.max) + ')" value="' + esc(lte) + '">' +
          '</div></details>';
      }

      host.innerHTML = html;
      host.hidden = false;
      if (aktifMi()) toplamiGuncelle();
    });
  }

  // Stil (tek sefer)
  (function () {
    if (document.getElementById('ykyf-stil')) return;
    var st = document.createElement('style'); st.id = 'ykyf-stil';
    st.textContent =
      '.ykyf{display:grid;gap:4px;margin-top:8px}' +
      '.ykyf-secili{font-size:13px;line-height:1.6;padding:10px 0;border-bottom:1px solid rgb(0 0 0/.08)}' +
      '.ykyf-secili em{font-style:normal;display:inline-block;padding:2px 10px;margin:2px 2px;border-radius:999px;background:rgb(0 0 0/.06)}' +
      '.ykyf-temizle{margin-left:6px;text-decoration:underline;text-underline-offset:3px}' +
      '.ykyf-stok{display:flex;align-items:center;gap:10px;padding:14px 0;border-bottom:1px solid rgb(0 0 0/.08);cursor:pointer}' +
      '.ykyf-grup{border-bottom:1px solid rgb(0 0 0/.08)}' +
      '.ykyf-grup>summary{list-style:none;cursor:pointer;padding:16px 0;font-size:1.05rem;font-weight:500;display:flex;align-items:center;gap:8px}' +
      '.ykyf-grup>summary::-webkit-details-marker{display:none}' +
      '.ykyf-grup>summary::after{content:"+";margin-left:auto;font-weight:400}' +
      '.ykyf-grup[open]>summary::after{content:"\\2013"}' +
      '.ykyf-sayi{font-size:11px;min-width:18px;height:18px;border-radius:999px;background:currentColor;display:inline-grid;place-items:center}' +
      '.ykyf-sayi{color:#fff;background:#111}' +
      '.ykyf-icerik{padding:0 0 14px}' +
      '.ykyf-icerik ul{list-style:none;margin:0;padding:0;display:grid;gap:8px;max-height:320px;overflow:auto}' +
      '.ykyf-icerik label{display:flex;align-items:center;gap:10px;cursor:pointer;font-size:14px}' +
      '.ykyf-adet{opacity:.55;font-size:12px}' +
      '.ykyf-gizli{display:none!important}' +
      '.ykyf-ara{width:100%;margin:0 0 10px;padding:9px 12px;border:1px solid rgb(0 0 0/.15);border-radius:999px;font-size:14px}' +
      '.ykyf-daha{margin-top:10px;font-size:13px;text-decoration:underline;text-underline-offset:3px;background:none;border:0;padding:0;cursor:pointer}' +
      '.ykyf-fiyat{display:flex;align-items:center;gap:10px}' +
      '.ykyf-fiyat input{width:100%;padding:9px 12px;border:1px solid rgb(0 0 0/.15);border-radius:10px;font-size:14px}';
    document.head.appendChild(st);
  })();

  // Arama kutusu ve "daha fazla" (form değişimi tetiklemez)
  document.addEventListener('input', function (e) {
    var ara = e.target.closest && e.target.closest('.ykyf-ara');
    if (!ara) return;
    e.stopPropagation();
    var t = ara.value.trim().toLowerCase();
    var grup = ara.closest('.ykyf-grup');
    grup.querySelectorAll('.ykyf-satir').forEach(function (li, i) {
      var uyar = !t || li.getAttribute('data-ad').indexOf(t) !== -1;
      li.classList.toggle('ykyf-gizli', t ? !uyar : (i >= ILK_GOSTER && !li.querySelector('input').checked));
    });
  }, true);
  // arama kutusundaki "change" temanın filtre formunu tetiklemesin
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.ykyf-ara')) e.stopPropagation();
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.ykyf-daha');
    if (!b) return;
    b.closest('.ykyf-grup').querySelectorAll('.ykyf-gizli').forEach(function (li) { li.classList.remove('ykyf-gizli'); });
    b.remove();
  });

  function hepsiniCiz() {
    document.querySelectorAll('[data-yk-yedek-filtre]').forEach(function (host) {
      if (!host.hasAttribute('data-ykyf-cizildi')) { host.setAttribute('data-ykyf-cizildi', ''); ciz(host); }
    });
  }

  // Tema filtre sonrası bölümü yeniden çizince: seçili listeyi ve sayıyı tazele
  document.addEventListener('collection:reloaded', function () {
    document.querySelectorAll('[data-yk-yedek-filtre]').forEach(function (host) { ciz(host); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hepsiniCiz);
  else hepsiniCiz();
  new MutationObserver(hepsiniCiz).observe(document.documentElement, { childList: true, subtree: true });
})();
